import MeterUnit from "../../../utils/services/project/metering/meterUnitService";
import crudTemplate from "../../../templates/crudTemplate";
import predecessorsAndSuccessorsTemplate from "../../../templates/predecessorsAndSuccessorsTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(MeterUnit);
let predecessorsAndSuccessors = predecessorsAndSuccessorsTemplate(MeterUnit);
function prepareItem(i) {
  if (typeof i !== "object" || i === null) {
    return i;
  }
  i._source = i._source || { id: null };
  i.source_id = (i._source && i._source.id) || null;
  i.source_name =
    (i._source && i._source.id && i._source.name) ||
    i18n.t("meter-units.manual-input");

  i._meter = i._meter || { id: null };
  if (i._meter && i._meter._group) {
    i.path =
      [...(i._meter._group._ancestors || []), i._meter._group]
        .filter(i => !!i)
        .map(i => ({ ...i, to: "group" })) || [];
    i.path.push({ ...i._meter, to: "meter" });
  }
  i._group = i._group || {};

  i.is_monitored = i.monitored_since != null;

  i._ingestion = i._ingestion || { id: null };
  i.tariffs = i._ingestion._tariffs;
  i.ingestion_id = (i._ingestion && i._ingestion.id) || null;
  i.ingestion_name =
    (i._ingestion && i._ingestion.id && i._ingestion.name) || " ";
  i._visualization = i._visualization || { id: null };
  i.visualization_id = (i._visualization && i._visualization.id) || null;
  i.visualization_name = (i._visualization && i._visualization.name) || null;
  return i;
}
const state = {
  ...crud.state,
  ...predecessorsAndSuccessors.state
};
const getters = {
  ...crud.getters,
  ...predecessorsAndSuccessors.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getListSuccessors(state) {
    let list = predecessorsAndSuccessors.getters.getListSuccessors(state);
    return list.map(i => ({ ...i, ...prepareItem(i._meter_unit) }));
  },
  getListPredecessors(state) {
    let list = predecessorsAndSuccessors.getters.getListPredecessors(state);
    return list.map(i => ({ ...i, ...prepareItem(i._meter_unit) }));
  },
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  },
  getTariffFromItem(state) {
    let item = crud.getters.getItem(state);
    return item._tariffs || [];
  }
};

const actions = {
  ...crud.actions,
  ...predecessorsAndSuccessors.actions
};

const mutations = {
  ...crud.mutations,
  ...predecessorsAndSuccessors.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
